export const Config = { apiUrl: 'https://api.tal-software.com/api' };
// export const Config = { apiUrl: 'http://testapi.tal-software.com/api' };
// export const Config = { apiUrl: 'http://localhost:51811/api' };

/*
INFO: API Configuration

It is not possible to authenticate on the productive API from localhost. 
Authentication only works from tal-software.com.

You need to start the server on the development machine with development mode enabled 
and connect to that API with the config above.

Don't forget to switch back to the productive API before building for production.

TODO: auto switch API based on environment variable or something like that.
*/